import { oc } from '@orpc/contract';
import { previewVehicleSaleInputSchema, vehicleSalePreviewSchema } from '../schemas/vehicles.schemas.js';
/**
 * Read-only: what a sale at this price on this date would be measured against (plan §5.6).
 *
 * It runs the **same** rule `changeStatus` runs, on the vehicle priced as sold, and writes nothing. The
 * sale dialog asks for it as the price and the date are typed, so "below the required retail" on screen
 * is the service's answer rather than the browser's guess at one — the live required retail a dossier
 * shows is the larger figure, and comparing against it sent salespeople to find an administrator for
 * sales that needed nobody.
 */
export const previewVehicleSaleContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/{vehicleId}/sale-preview',
    tags: ['Vehicles'],
    summary: 'Preview the required retail a sale would be measured against',
})
    .input(previewVehicleSaleInputSchema)
    .output(vehicleSalePreviewSchema);
//# sourceMappingURL=preview-vehicle-sale.contract.js.map